
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/widget/recommends/[...trip_ids]",
      function () {
        return require("private-next-pages/widget/recommends/[...trip_ids].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/widget/recommends/[...trip_ids]"])
      });
    }
  